import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38b20fc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "signup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "signup-heading" }, "Own a Cooperative Society? Join Us Now", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-para" }, " We are creating seamless financial solutions for cooperatives, helping you achieve your goals without hassles. ", -1))
const _hoisted_4 = { class: "signup-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "namem" }, "Name of cooperative society", -1))
const _hoisted_6 = { class: "signup-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "descrition" }, "Description of cooperative society ", -1))
const _hoisted_8 = { class: "signup-box d-flex justify-content-between" }
const _hoisted_9 = { class: "signup-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Year of establishment", -1))
const _hoisted_11 = { class: "signup-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City of operation", -1))
const _hoisted_13 = { class: "signup-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "primaryObjective" }, "State primary objective", -1))
const _hoisted_15 = { class: "signup-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address", -1))
const _hoisted_17 = { class: "signup-box d-flex justify-content-between" }
const _hoisted_18 = { class: "signup-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State", -1))
const _hoisted_20 = { class: "signup-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country" }, "Country", -1))
const _hoisted_22 = { class: "signup-box d-flex justify-content-between" }
const _hoisted_23 = { class: "signup-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nummem" }, "Number of Members", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signup-group" }, null, -1))
const _hoisted_26 = { class: "signup-group mb-0" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "maxil" }, "Maximum individual loan capacity disbursement", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "signup-heading signup-heading-1" }, "Representative Details", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "signup-para" }, " Complete application form to get tarted as a Cooperative Society ", -1))
const _hoisted_30 = { class: "signup-box d-flex justify-content-between" }
const _hoisted_31 = { class: "signup-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Title", -1))
const _hoisted_33 = { class: "signup-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "Gender", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "male" }, "Male", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "female" }, "Female", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "signup-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Full name", -1))
const _hoisted_40 = { class: "signup-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phoneNumber" }, "Phone Number", -1))
const _hoisted_42 = { class: "signup-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_44 = { class: "signup-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address", -1))
const _hoisted_46 = { class: "signup-group d-flex align-items-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "agree",
  class: "mb-0 ms-3"
}, "We agree to the terms and conditions of BeHalal", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { countdown: _ctx.countHandler }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_ctx.alert)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["alert signup-alert", _ctx.error ? 'alert-danger' : 'alert-success']),
              role: "alert"
            }, _toDisplayString(_ctx.message), 3))
          : _createCommentVNode("", true),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signup && _ctx.signup(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "namem",
              placeholder: "Input cooperative society name here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cooperative_name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.cooperative_name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("textarea", {
              type: "text",
              id: "descrition",
              placeholder: "Input description.",
              class: "form-control signup-input",
              rows: "6",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event))
            }, null, 512), [
              [_vModelText, _ctx.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "year",
                id: "year",
                placeholder: "select",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year_of_establishment) = $event))
              }, null, 512), [
                [_vModelText, _ctx.year_of_establishment]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "city",
                placeholder: "Input here",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.city_of_operation) = $event))
              }, null, 512), [
                [_vModelText, _ctx.city_of_operation]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "primaryObjective",
              placeholder: "Input objectives here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.primary_objective) = $event))
            }, null, 512), [
              [_vModelText, _ctx.primary_objective]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "address",
              placeholder: "Input here",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.address]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "state",
                placeholder: "select",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state) = $event))
              }, null, 512), [
                [_vModelText, _ctx.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "country",
                placeholder: "select",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.country) = $event))
              }, null, 512), [
                [_vModelText, _ctx.country]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "nummem",
                placeholder: "Input here",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.no_of_members) = $event))
              }, null, 512), [
                [_vModelText, _ctx.no_of_members]
              ])
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "maxil",
              placeholder: "Tell us the maximum loan a member has collected",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.loan_capacity) = $event))
            }, null, 512), [
              [_vModelText, _ctx.loan_capacity]
            ])
          ]),
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "title",
                placeholder: "E.g Mr, Mrs, Prof",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rep_title) = $event))
              }, null, 512), [
                [_vModelText, _ctx.rep_title]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("select", {
                id: "gender",
                placeholder: "select",
                class: "form-control signup-input",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rep_gender) = $event))
              }, _hoisted_37, 512), [
                [_vModelSelect, _ctx.rep_gender]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              placeholder: "Input here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rep_fullname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.rep_fullname]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _withDirectives(_createElementVNode("input", {
              type: "number",
              id: "phoneNumber",
              placeholder: "Input here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.phonenumber) = $event))
            }, null, 512), [
              [_vModelText, _ctx.phonenumber]
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "email",
              placeholder: "Input here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.rep_email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.rep_email]
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "address",
              placeholder: "Input here.",
              class: "form-control signup-input",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.rep_address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.rep_address]
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "agree",
              placeholder: "Input here.",
              class: "signup-check",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.agree) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.agree]
            ]),
            _hoisted_47
          ]),
          _createVNode(_component_Button, {
            type: "blue",
            name: "Sign Up Now.",
            class: "signup-btn"
          })
        ], 32)
      ])
    ]),
    _: 1
  }, 8, ["countdown"]))
}